// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"56":"56bf960c","302":"d4d14b9e","370":"8aff65ad","443":"f03892f9","895":"dde56517"}[chunkId] + ".js";
};